import { apiAxios } from "./api-config/axiosConfig";

export interface AddressSearchResult {
  id?: number;
  streetStart: number;
  streetName: string;
  streetAddress?: string;
  addressLine1?: string;
  city: string;
  county?: string;
  postalCode?: string;
  xCoordinate: number;
  yCoordinate: number;
  isPrimary?: string;
  distance?: number;
  description?: string;
  state?: {
    value: string;
    text: string;
  };
  country?: {
    value: string;
    text: string;
  };
  addressTypeFlag?: {
    value: string;
    text: string;
  };
}

export const homeApis = {
  searchAddresses: async (params: {
    streetName?: string;
    streetStart?: string;
  }): Promise<AddressSearchResult[]> => {
    try {
      const token = localStorage.getItem("LVaccessToken");
      const response = await apiAxios.post<{
        result?: AddressSearchResult[];
        data?: AddressSearchResult[] | { result?: AddressSearchResult[] };
        message?: string;
      }>(
        "/inspector/addresses/search",
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const results = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data.result)
          ? response.data.result
          : Array.isArray(response.data.data)
            ? response.data.data
            : response.data.data?.result || [];

      if (!results.length) {
        throw new Error(response.data.message || "No matching location found.");
      }

      return results;
    } catch (error: any) {
      console.error("Address Search API Error:", error);
      throw error?.response?.data || error;
    }
  },

  getInspectorReports: async (inspectorId: string) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const response = await apiAxios.get(`/report/inspector/${inspectorId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Inspector Report API Error:", error);
      throw error?.response?.data || error;
    }
  },

  submitReport: async (payload: {
    reportDetails: {
      streetStart: number;
      isPrimary: string;
      addressLine1: string;
      city: string;
      county: string;
      state: {
        text: string;
        value: string;
      };
      country: {
        text: string;
        value: string;
      };
      postalCode: string;
      streetName: string;
      distance: number;
      xCoordinate: number;
      yCoordinate: number;
      description: string;
      addressTypeFlag: {
        text: string;
        value: string;
      };
      notes: string;
      illegalSmoking: string;
      zoningConcern: string;
      licenseConcern: string;
    };
    fileDetails: {
      filename: string;
      type: string;
      description: string;
    }[];
    files: File[];
    insertIntoAccela: boolean;
  }) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const formData = new FormData();
      formData.append(
        "report_details",
        JSON.stringify([payload.reportDetails]),
      );
      formData.append(
        "report_file_detail",
        JSON.stringify(payload.fileDetails),
      );
      formData.append("insertIntoAccela", String(payload.insertIntoAccela));
      payload.files.forEach((file) => {
        formData.append("file", file);
      });

      const response = await apiAxios.post(`/report/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Submit Report API Error:", error);
      throw error?.response?.data || error;
    }
  },
};
